function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useEffect, useRef } from 'react';
import c from 'classnames';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { Button as RKSButton, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_TEXT } from '../../../config/constants';
import SearchReset from '../../Reset';
import './style.scss';

// @TODO: Put this in @uncinc/uncinc-react-kitchen-sink later on.

const SearchBarBase = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    t
  } = useTranslation();
  const timeoutRef = useRef();
  const {
    initialQuery = '',
    title,
    placeholder = t(['searchkit.search_bar.placeholder', DEFAULT_TEXT.SEARCH_BAR.PLACEHOLDER]),
    button,
    buttonText = t(['searchkit.buttons.search', DEFAULT_TEXT.BUTTONS.SEARCH]),
    autoSearch = false,
    timeout = 1000,
    className,
    minSearchLength = 0,
    autoFocus = false,
    onSubmit,
    fieldName = 'query',
    showReset,
    resetProps,
    InputComponent,
    ...restProps
  } = props;
  const classNames = c('SearchBar', className);
  const Button = button || RKSButton;
  const Input = InputComponent || Field;
  const handleChange = event => {
    var _event$target;
    event.persist();
    if ((event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 || (_event$target = _event$target.value) === null || _event$target === void 0 ? void 0 : _event$target.length) < minSearchLength) {
      return;
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      onSubmit(event.target.value);
    }, timeout);
  };
  useEffect(() => {
    if (ref && ref.current && autoFocus) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
    }
  }, [ref, autoFocus]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(FormikWrapper, {
    initialValues: {
      [fieldName]: initialQuery
    },
    enableReinitialize: true,
    onSubmit: (values, _ref) => {
      let {
        setSubmitting
      } = _ref;
      onSubmit(values[fieldName]);
      setSubmitting(false);
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement("label", {
    htmlFor: fieldName,
    className: "SearchBar__label"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "SearchBar__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "TextField"
  }, /*#__PURE__*/React.createElement(Input, _extends({}, restProps, {
    innerRef: ref,
    name: fieldName,
    placeholder: placeholder
  }, autoSearch ? {
    onKeyUp: handleChange
  } : {}))), showReset && initialQuery && /*#__PURE__*/React.createElement(SearchReset, _extends({}, resetProps, {
    resetRefinements: false
  })), !autoSearch && /*#__PURE__*/React.createElement(Button, {
    htmlType: "submit",
    className: "SearchBar__submit"
  }, buttonText)))));
});
export default SearchBarBase;